var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAdminPortal
    ? _c("div", [
        _c(
          "button",
          {
            staticClass: "btn btn-link px-0",
            attrs: { disabled: _vm.populating },
            on: { click: _vm.checkShippingPackagesByCategory },
          },
          [
            _vm.populating
              ? _c("i", { staticClass: "far fa-spinner-third fa-spin" })
              : _vm._e(),
            _vm._v(" Update\n    "),
            !_vm.category ? _c("span", [_vm._v("All Product")]) : _vm._e(),
            _vm._v(" Shipping Dimensions\n  "),
          ]
        ),
        _c("i", {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover",
              modifiers: { hover: true },
            },
          ],
          staticClass: "fas fa-question-circle ml-1 text-light",
          attrs: {
            title: `Auto populate shipping with data from the average of all shipping packages for all products that belong to this category`,
          },
        }),
        _vm.checking
          ? _c("div", { staticClass: "progress flex-fill mt-1" }, [
              _c(
                "div",
                {
                  staticClass: "progress-bar",
                  style: `width: ${_vm.checking}%;`,
                  attrs: { role: "progressbar" },
                },
                [_vm._v(_vm._s(_vm.checking) + "%")]
              ),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }